/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

import { UserManagement } from '../components/auth/UserManagement';

export function UserManagementPage() {
  return <UserManagement />;
}
